import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
// import './App.css';

export default class Header extends Component {
  render() {
    // var handleUpdateLanguage3 =  this.props.handleUpdateLanguage;

    const productImageStyle = {
      maxHeight: '35px',
      verticalAlign: 'baseline'
    }

    var preseliNameStyle = {
      fontSize: '48px',
      verticalAlign: 'baseline'
    }

    // Set language styling for chinese
    if(this.props.language == "chi"){
      var preseliNameStyle = {
        fontSize: '48px',
        verticalAlign: 'baseline',
        fontFamily: "'微軟正黑體', 'Microsoft Yahei', 'serif', 'Arial','Open Sans'"
      }
    } else {
      var preseliNameStyle = {
        fontSize: '48px',
        verticalAlign: 'baseline'
      }
    }

    const translationTextContactUsNow = { en: "Contact Us Now", chi: "立即聯繫我們" }
    const translationTextPreseli = { en: "Preseli ", chi: "百事利" }
    const translationTextEngSupply = { en: "Engineering Supplies Ltd", chi: "器材有限公司" }



    return (

      //  {/*Header & Branding region*/}
      < div className="header" >
        {/* all direct children of the .header-inner element will be vertically aligned with each other you can override all the behaviours using the flexbox utilities (flexbox.htm) All elements with .header-brand & .header-block-flex wrappers will automatically be aligned inline & vertically using flexbox, this can be overridden using the flexbox utilities (flexbox.htm) Use .header-block to stack elements within on small screen & "float" on larger screens use .flex-first or/and .flex-last classNamees to make an element show first or last within .header-inner or .headr-block elements -->*/}
        < div className="header-inner container" >
          {/*//*<!--branding/logo -->*/}
          < div className="header-brand flex-first " >
            <NavLink strict to="/" className="header-brand-text" title="Home">
              <h1>
                <img style={productImageStyle} className="img-fluid img-responsive img-rounded pr-1" src="../img/icons/preseli-engineering-logo.png" ></img>
                <span style={preseliNameStyle}>{translationTextPreseli[this.props.language]}</span><span></span>
              </h1>
            </NavLink>
            <div className="header-divider hidden-md-down"></div>
            <div className="header-slogan hidden-md-down">{translationTextEngSupply[this.props.language]}</div>
          </div >
          {/*// other header content*/}
          < div className="header-block flex-last" >
            <div className="d-flex flex-column text-right hidden-md-down mr-2">
              <h6 className="my-0 mb-1">
                <u className="" role="button" onClick={this.props.handleUpdateLanguage.bind(this,"chi")}>中文</u> | <u role="button" onClick={this.props.handleUpdateLanguage.bind(this,"en")}>EN</u>
              </h6>
            </div>

            {/*<!-- mobile collapse menu button - data-toggle="collapse" = default BS menu - data-toggle="jpanel-menu" = jPanel Menu - data-toggle="overlay" = Overlay Menu -->*/}
            <a href="#top" className="btn btn-link btn-icon header-btn float-right hidden-lg-up" data-toggle="jpanel-menu" data-target=".navbar-main" data-direction="right"> <i className="fa fa-bars"></i> </a>
            <div className="header-divider hidden-md-down"></div>
            <div className="d-flex flex-column text-right hidden-md-down mr-2">
              <h6 className="my-0 mb-1">
                <i className="fa fa-info text-primary"></i>
                {translationTextContactUsNow[this.props.language]}
              </h6>
              <h6 className="my-0 text-muted font-weight-normal">
                <i className="fa fa-phone text-primary"></i>
                (+852) 24236378
              </h6>
            </div>



          </div >
        </div >
      </div >

    );
  }
}


// WEBPACK FOOTER //
// ./src/container/Header.js